import { OrbitControls, OrbitControlsProps } from "@react-three/drei";
import React from "react";
import { Scene } from "../../Types";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { useCameraPositionStore } from "../../state management/zustand/gl-stores";

const Controls = (props: { scene: Scene; zoom: number }) => {
  const { scene, zoom } = props;

  const maxPolarAngle = React.useMemo(() => {
    if (scene.lockRotation) return Math.PI / 2;
    else return Math.PI;
  }, [scene.lockRotation]);

  const minPolarAngle = React.useMemo(() => {
    if (scene.lockRotation) return Math.PI / 2;
    else return 0;
  }, [scene.lockRotation]);

  const initialPosition = React.useMemo(() => {
    const initial = new THREE.Vector3(0, 1, 0);
    return initial;
  }, []);

  const camera = useCameraPositionStore();

  useFrame((state) => {
    const controls = state.controls as OrbitControlsProps;

    const perspCamera = controls.object;

    if (camera.cameraLookAt && perspCamera) {
      const distance = perspCamera.position.distanceTo(camera.cameraLookAt);
      perspCamera.position.lerp(camera.cameraLookAt, 0.15);

      controls.enableRotate = false;
      if (distance < 0.01) {
        controls.enableRotate = true;

        camera.resetCameraLookAt();
      }
    }
  });
  return (
    <OrbitControls
      makeDefault
      position0={initialPosition}
      maxPolarAngle={maxPolarAngle}
      minPolarAngle={minPolarAngle}
      enablePan={false}
      reverseOrbit
      enableDamping={false}
      enableZoom={false}
      rotateSpeed={zoom * 0.003}
      maxDistance={200}
    />
  );
};

export default Controls;

// const distance = camera.position.distanceTo(cameraPos);

// camera.position.lerp(cameraPos, 0.15);
// if (distance < 0.01) {
//   setCameraPos(undefined);
// }
